import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { ExtraWideBody } from '@ui';
import { GRID_MODES } from '@containers/gridMode';

import TableAnalysisTool from '@containers/TableAnalysis/TableAnalysisTool';
import { AI_TOOLS } from '@constants';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.CREDIT_AGREEMENT_ANALYSIS;

function CreditAgreementAnalysis() {
  const [docMode] = React.useState(GRID_MODES.credit);

  return (
    <PageWrapper>
      <Header />
      <ExtraWideBody withFooter>
        <TableAnalysisTool docMode={docMode} tool={tool} />
      </ExtraWideBody>
    </PageWrapper>
  );
}

export default CreditAgreementAnalysis;
